export class ViewStateSortOders {
    public static ASC: string = 'asc';
    public static DESC: string = 'desc';
}
